module.exports = "<div> נשמח לתכנן איתך יחדיו את החבילה, שתותאם באופן אישי לצרכיך, בצורה הטובה ביותר, בהתאם לכמות המודעות והקידומים בהם אתה מעוניין.</div> <div>ב-OnMap המודעות שלך יזכו ליחס שיוויוני ויוצגו בפני הגולשים - עם שאר המודעות הפרטיות - ללא הפרדה!<br/> ומעבר לזה…אנחנו נחשוף אותך בפני קהל רחב של לקוחות פוטנציאליים.<br> אם תרצה, יחדיו נקים לך ולמשרד שלך עמוד ב-OnMap! בעמוד תוכל לספר על עצמך ועל העסק שלך, על עסקאות שנסגרו על ידי המשרד ולקדם נכסים למכירה ולהשכרה. </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/publishContactUs/he.md
// module id = 831
// module chunks = 0